// ListHub Platform Event Tracking expects lkey as 3yd-[SystemSourceId]-[ListingId]
// with everything after the "3yd" prefix uppercased. We store keys downcased
// (see Listhub::Importer), so format them before sending.
export const formatListhubKey = (listhubKey) =>
  listhubKey
    .split("-")
    .map((part, index) => (index === 0 ? part : part.toUpperCase()))
    .join("-");

const submit = (eventType, payload) => {
  if (typeof window.lh !== "function") return;

  window.lh("submit", eventType, payload);
};

export const trackListhubSearchDisplay = (properties) => {
  const listings = properties
    .filter((property) => property.listhub_key)
    .map((property) => ({ lkey: formatListhubKey(property.listhub_key) }));

  submit("SEARCH_DISPLAY", listings);
};

export const trackListhubDetailPageViewed = (listhubKey) => {
  if (!listhubKey) return;

  submit("DETAIL_PAGE_VIEWED", { lkey: formatListhubKey(listhubKey) });
};
